/**
 * poppet.View
 * An extended Marionette View, the basic poppet.View.
 * @version 0.8.6
 */

const channelNav = Bb.Radio.channel( 'nav' );

const selectors = {
	cancel: '[data-click$=cancel]',
	close : '[data-click$=close]',
	submit: '[data-click$=submit]',
};

const View = Mn.View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	tagName      : 'section',
	className    : 'card',
	closeBehavior: 'animate',
	
	mainRegion       : false,
	noAnimate        : false,
	noEnterKeypress  : false,
	noBusy           : false,
	noSuccessFeedback: false,
	noInitValidation : false,
	
	behaviors: {
		ViewAnimator: {},
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// - lifecycle event handlers
	
	/**
	 * @constructor
	 */
	initialize: function ( options ) {
		
		this.settings( options );
		this.$el.attr( 'data-cid', this.cid );
		
		Mn.View.prototype.initialize.call( this, this.options );
	},
	
	/**
	 * Triggers when this view is destroyed.
	 * @void
	 */
	onDestroy: function () {
		this.stopListening();
	},
	
	/**
	 * Triggers when a view triggers "cancel". Asks the view to animate out.
	 * @void
	 */
	onChildviewCancel: function ( childView ) {
		if ( childView && _.isFunction( childView.animateOut ) && 'animate' === childView.closeBehavior ) {
			childView.animateOut();
		}
	},
	
	/**
	 * Triggers when a childView triggers "close". Asks the childView to animate out.
	 *
	 * Note: this is now a mirror of onChildCancel, but can be overwritten
	 *       to handle close events without changing default cancel behavior.
	 * @void
	 */
	onChildviewClose: function ( childView ) {
		if ( childView && _.isFunction( childView.animateOut ) && 'animate' === childView.closeBehavior ) {
			childView.animateOut();
		}
	},
	
	/**
	 * Triggers when a childView is done animating out. Attempts to change url. Ignores nested poppet.Layouts.
	 * @void
	 */
	onChildviewAnimateOut: function ( childView ) {
		console.group( 'onChildviewAnimateOut' );
		console.trace();
		console.log( 'closeLink' );
		console.log( childView.closeLink );
		if ( _.isObject( childView.closeLink ) ) {
			
			let obj = childView.closeLink;
			channelNav.trigger( obj.event, obj.params, obj.options );
			
			// !TODO: to be deprecated
		}
		/*else if (_.isString(childView.closeLink)) {
		 Bb.history.navigate(childView.closeLink, {trigger: true});
		 }*/
		
		console.groupEnd();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Changes the stored options object of the layout.
	 * @void
	 */
	settings: function ( options ) {
		
		this.options = this.options || {};
		
		if ( options ) {
			_.extend( this.options, options );
		}
		
		if ( this.options.closeLink ) {
			this.closeLink = this.options.closeLink;
		}
	},
	
	/**
	 * Animates out a childview, if it exists.
	 * @param {object} options  Options for what happens when the view is animated out.
	 * @void
	 */
	animateChildOut: function ( options ) {
		
		options = options || {};
		
		let view = options.view || this.getRegion( this.mainRegion ).currentView || false;
		
		if ( view instanceof View ) {
			view.closeLink = options.closeLink || view.closeLink;
			view.animateOut();
		}
	},
	
	/**
	 * Adding the closeLink parameter to the showChildView container.
	 * @param {string} region       The Layout Region to place a View in.
	 * @param {View}   view         The View to place in the Region.
	 * @param {object} [closeLink]  The url to goto if the is View is closed by cancel.
	 *
	 * @overwrite
	 * @void
	 */
	showChildView: function ( region, view, closeLink ) {
		// set the closeLink, by direct command or class defaults or view inheritance.
		view.closeLink = closeLink || view.closeLink || this.closeLink || false;
		
		// a closeLink set to false, should always be false / diregarding class defaults or view inheritance.
		if ( _.isBoolean( closeLink ) && !closeLink ) {
			view.closeLink = false;
		}
		
		Mn.View.prototype.showChildView.call( this, region, view );
	},
	
	// - primary buttons-handling
	
	/**
	 * Enables the submit buttons of a form, while removing the close button.
	 * @void
	 */
	enableSubmit: function () {
		
		this.showElement( this.$el.find( selectors.cancel ) );
		this.hideElement( this.$el.find( selectors.close ) );
		this.showElement( this.$el.find( selectors.submit ) );
	},
	
	/**
	 * Disables the submit buttons of a form, while removing the close button.
	 * @void
	 */
	disableSubmit: function () {
		
		this.showElement( this.$el.find( selectors.cancel ) );
		this.hideElement( this.$el.find( selectors.close ) );
		this.disableElement( this.$el.find( selectors.submit ) );
	},
	
	/**
	 * Hides the submit and cancel buttons, and shows the close-button.
	 * @void
	 */
	closeSubmit: function () {
		
		this.hideElement( this.$el.find( selectors.cancel ) );
		this.showElement( this.$el.find( selectors.close ) );
		this.hideElement( this.$el.find( selectors.submit ) );
	},
	
	/**
	 * Hides the submit button.
	 * @void
	 */
	hideSubmit: function () {
		
		this.hideElement( this.$el.find( selectors.cancel ) );
		this.hideElement( this.$el.find( selectors.close ) );
		this.hideElement( this.$el.find( selectors.submit ) );
	},
	
	// - element handling
	
	/**
	 * Attempts to get a jQuery object by testing objects and strings against certain view-parameters.
	 * @param {*} element  String or jQuery object to be validated as an element holding jQuery object.
	 * @return {jQuery}    A jQuery object containing said element.
	 */
	getElement: function ( element ) {
		let target = false;
		
		element = ( _.isString( element ) )
				  ? element.trim()
				  : element;
		
		if ( element instanceof $ ) {
			target = element;
		} else if ( this.ui && _.isObject( this.ui[ element ] ) ) {
			target = this.ui[ element ];
		} else {
			target = $( element );
		}
		
		return target;
		
	},
	
	/**
	 * Gets a url query string value by it's key.
	 * @param  {string} key  The query string key to get.
	 * @return {string}      The query string value.
	 */
	getQueryValue: function ( key ) {
		
		let query = window.location.search.substring( 1 ),
			vars  = query.split( '&' );
		
		for ( let i = 0; i < vars.length; i++ ) {
			let pair = vars[ i ].split( '=' );
			
			if ( pair[ 0 ] == key ) {
				return pair[ 1 ];
			}
		}
		
		return false;
	},
	
	/**
	 * Hides an element.
	 * @param {*} element  jQuery Object or a string representing a jQuery object through css or this.ui.
	 * @void
	 */
	hideElement: function ( element ) {
		element = this.getElement( element );
		if ( _.isFunction( element.prop ) ) {
			element.prop( 'hidden', true );
		}
	},
	
	/**
	 * Disables an element.
	 * @param {*} element  jQuery Object or a string representing a jQuery object through css or this.ui.
	 * @void
	 */
	disableElement: function ( element ) {
		element = this.getElement( element );
		if ( _.isFunction( element.prop ) ) {
			element.prop( 'disabled', true );
		}
	},
	
	/**
	 * Shows an element.
	 * @param {*} element  jQuery Object or a string representing a jQuery object through css or this.ui.
	 * @void
	 */
	showElement: function ( element ) {
		element = this.getElement( element );
		if ( _.isFunction( element.removeAttr ) ) {
			element.removeAttr( 'hidden' ).removeAttr( 'disabled' );
		}
	},
	
} );

export default View;
